// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falT: CreateIconOptions = {
  "displayName": "FALT",
  "viewBox": "0, 0, 384, 512",
  "d": "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16l160 0 0 400c0 8.8 7.2 16 16 16s16-7.2 16-16l0-400 160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L192 32 16 32z"
};
